import _ from 'lodash';
import { Component, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { PagerService, AlertService, UserService, UserModel, CommonService, TableHeader, DataWithPages, UserAuthModel } from '../../services/index';
import { Util } from '../../utils/index';
import { Utils } from 'ag-grid';
import { SalesMessageModalComponent } from 'app/components';
import { UserNameModel } from 'app/services/sales.service';

declare var $:any;

@Component({
  selector: 'user-list',
  templateUrl: 'user-list.html' 
})
export class UserList {
  
  tempPage:number = 0;
  pager: any = {};
  pagedItems: any[];
  userList:DataWithPages = new DataWithPages();
  tempUserList = new Array();
  searchOption:SearchOption = new SearchOption();

  getUserListSub:Subscription;

  pageDatas;

  page: number = 1;

  hideMore : boolean = false;

  allCount:number = 0;

  phoneFormatter: Function = Util.phoneFormatter;
  dateFomatter:Function = Util.getDtmLocalStr;  

  isOpenUserInfo = false;
  openUserInfo:UserModel = new UserModel();
  headerList:Array<TableHeader> = null; 

  @ViewChild('salesMessageModal') salesMessageModal: SalesMessageModalComponent;

  constructor(
    private pagerService: PagerService,
    private userService: UserService,
    private commonService:CommonService
  ){
    commonService.headerSortedEmit.subscribe(sortedData =>{
      this.tempUserList = sortedData;
      this.setPage(1);
    });
    commonService.clearHeaderEmit.subscribe(headers =>{
      this.headerList = headers;
    });
  }

  ngOnInit() {
    this.makeHeader();
    this.search(1);
  }

  makeHeader(){
    this.headerList = new Array<TableHeader>();
    this.headerList.push(new TableHeader(0, 'userId', 'No.', true));
    this.headerList.push(new TableHeader(1, 'email', '이메일', false));
    this.headerList.push(new TableHeader(2, 'userTp', '사용자 구분', false));
    this.headerList.push(new TableHeader(3, 'jobTp', '직업 구분', true));
    this.headerList.push(new TableHeader(4, 'lastNm', '이름', false));
    this.headerList.push(new TableHeader(5, 'cmpnyNm', '회사명', false));
    this.headerList.push(new TableHeader(6, 'tel', '전화번호', false));
    this.headerList.push(new TableHeader(7, 'mobile', '휴대전화번호', false));
    this.headerList.push(new TableHeader(8, 'fax', 'FAX', false));
    this.headerList.push(new TableHeader(10, 'routeStusCd', '상태 코드', false));
    this.headerList.push(new TableHeader(9, 'cntryCd', '국가', false));
    this.headerList.push(new TableHeader(11, 'stusCd', '가입 상태', false));
    this.headerList.push(new TableHeader(12, 'regDt', '등록일시', true));
    this.headerList.push(new TableHeader(13, 'salesMessages', '메세지', false))
    this.headerList.push(new TableHeader(14, 'salesManager', '영업 담당자', false))
  }
  

  search(page, userId?:number){
    this.userService.getUserList2(1, 5000, res =>{
      this.userList = res;
      this.allCount = res.noOfElems;
      this.tempUserList = _.cloneDeep(this.userList.datas);
      if(this.searchOption.conditionText && this.searchOption.conditionText.length > 0){
        this.conditionSearch(page);
      }else{
        this.setPage(page);
      }      

      if(userId != null && userId > -1){
        this.detail(userId);
      }
    });
  }

  handleClickGetUserListMore() {
    this.page += 1;
    

    this.userService.getUserList2(this.page, 5000, res=>{
      
      if(res.datas) {
        this.userList.pageNo = res.pageNo;
        this.userList.noOfElems = res.noOfElems;
        this.userList.size = res.sizeNo;
        this.userList.totalElems = res.totalElems;
        this.userList.totalPages = res.totalPages;

        this.allCount += res.noOfElems;

        
        this.userList.datas = this.userList.datas.concat(res.datas);
        

        this.tempUserList = _.cloneDeep(this.userList.datas);

        if(this.userList.totalElems == this.allCount) {
          this.hideMore = true;
          return;
        } else {
          this.hideMore = false;
        }

        if(this.searchOption.conditionText && this.searchOption.conditionText.length > 0){
          this.conditionSearch(1);
        }else{
          this.setPage(1);
        }      
      };
      
      
    });
  }

  setPage(page: number) {
    if(_.isEmpty(this.userList.datas)) return;

    this.pager = this.pagerService.getPager(this.tempUserList.length, page);
    
    this.pagedItems = this.tempUserList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  userInfoClosed(event){
    this.isOpenUserInfo = false;
    if(event === true) this.search(this.pager.currentPage);
    else if(event && event['userId']) {
      let user = _.find(this.pagedItems, { userId : event.userId});
      for(let key in event) {
        user[key] = event[key];
      }
    }
  }

  conditionSearch(page?){
    if(_.isEmpty(this.userList.datas)) {
      return;
    }
    let keyword = _.upperCase(this.searchOption.conditionText).replace(/\s/gi, "");
    let statusCd = this.searchOption.conditionType;
    this.tempUserList = _.map(_.filter(this.userList.datas,
      (user:UserModel) => {
        let name = '';
        name = !user.firstNm ? user.lastNm : user.lastNm + user.firstNm;
        if(!keyword) return true;
        else if (_.upperCase(user.email).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(name).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(user.cmpnyNm).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(user.mobile).replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else return false;
      }));
    this.tempUserList = _.map(_.filter(this.tempUserList,
      (user:UserModel) => {
        if(statusCd == -1) return true;
        else if(statusCd == 0 && (user.jobTp != '0' || user.userAuthList == null || user.userAuthList.length == 0 || user.userAuthList[0].stusCd == 0)) return true;
        else if(statusCd == 1 && (user.jobTp == '0' && user.userAuthList != null && user.userAuthList.length > 0 &&  user.userAuthList[0].stusCd == 1)) return true;
        else if(statusCd == 2 && (user.jobTp == '0' && user.userAuthList != null && user.userAuthList.length > 0 &&  user.userAuthList[0].stusCd == 2)) return true;
        else if(statusCd == 3 && (user.jobTp == '0' && user.userAuthList != null && user.userAuthList.length > 0 &&  user.userAuthList[0].stusCd == 3)) return true;
        else if(statusCd == 99 && (user.jobTp == '0' && user.userAuthList != null && user.userAuthList.length > 0 &&  user.userAuthList[0].stusCd == 99)) return true;
        else return false;
      }));
    console.log(this.tempUserList);
    this.setPage(page == null || page == undefined ? 1 : page);
    this.commonService.clearOrderByHeader(this.headerList);
  }

  selectConditionType(event) {
    this.searchOption.conditionType = event;
    this.conditionSearch();
  }

  handleKeyDown(event){
    if(event.keyCode == 13) this.conditionSearch(1);
  }

  detail(userId?){
    this.isOpenUserInfo = true;
    if(userId){
      let temp;
      temp = _.filter(this.pagedItems,
        (user:UserModel) => {
          if(user.userId == userId) return true;
          else return false;
        }
      );
      this.openUserInfo = temp[0];
    }else{
      let userInfo = new UserModel();
      userInfo.cntryCd = "KR";
      this.userList.datas.push(userInfo);
      this.openUserInfo = userInfo;
    }
  }

  refreshUserDetail(userId:number){
    this.search(this.pager.currentPage, userId);
  }

  openMessageModal(user: UserModel) {
    const userFullName = (!user.firstNm ? user.lastNm : user.lastNm + user.firstNm);
    const jobTpTxt = (user.jobTp === '0' ? '화주' : user.jobTp === '1' ? '포워더' : user.jobTp === '2' ? '선사' : user.jobTxt);
    this.salesMessageModal.open(user.userId, userFullName, jobTpTxt, user.cmpnyNm);
  }

  getJobTpText(jobTp: string ) {
    if (jobTp === '99') return '';
    return Util.getJobTpText(jobTp);
  }

}

class SearchOption {
  conditionText:string;
  conditionType:number = -1;
}


// WEBPACK FOOTER //
// ./src/app/containers/user/user-list.ts